var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurcleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5009 11.8594C22.4212 6.06098 17.6587 1.42504 11.8603 1.50004C6.06183 1.57504 1.4259 6.34223 1.5009 12.1407C1.58058 17.9391 6.34308 22.575 12.1415 22.5C17.94 22.4204 22.5806 17.6579 22.5009 11.8594ZM12.0009 5.24536C12.8306 5.24536 13.5009 5.91567 13.5009 6.74536C13.5009 7.57504 12.8306 8.24536 12.0009 8.24536C11.1712 8.24536 10.5009 7.57504 10.5009 6.74536C10.5009 5.91567 11.1712 5.24536 12.0009 5.24536ZM14.0634 18.5157H9.9384V18H10.9696V10.5H9.9384V9.93754H13.0321V18H14.0634V18.5157Z",
    fill: "#2871DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurcleInfo);
export default __webpack_public_path__ + "static/media/curcleInfo.94933ba9c63a2cd3c6e4a3f70b727d07.svg";
export { ForwardRef as ReactComponent };